import { __rest } from 'tslib';
import React from 'react';
import { useColor } from '../../theme/Theme.js';
import { Icon } from '../Icon.js';

const ChevronRight = React.forwardRef((_a, ref) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const _color = useColor(color);
    return (React.createElement(Icon, Object.assign({ "data-testid": 'tend-ui-chevron-right-icon' }, props, { ref: ref, color: _color }),
        React.createElement("svg", { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'currentColor', xmlns: 'http://www.w3.org/2000/svg' },
            React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M9.79289 17.7071C9.40237 17.3166 9.40237 16.6834 9.79289 16.2929L14.0858 12L9.79289 7.70711C9.40237 7.31658 9.40237 6.68342 9.79289 6.29289C10.1834 5.90237 10.8166 5.90237 11.2071 6.29289L16.2071 11.2929C16.5976 11.6834 16.5976 12.3166 16.2071 12.7071L11.2071 17.7071C10.8166 18.0976 10.1834 18.0976 9.79289 17.7071Z', fill: 'currentColor' }))));
});
ChevronRight.displayName = 'ChevronRight';

export { ChevronRight };
//# sourceMappingURL=ChevronRight.js.map
